export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('app:created', (app) => {
    /**
     * Set the `idPrefix` used to generate unique IDs in the app
     * https://vuejs.org/api/composition-api-helpers.html#useid
     */
    app.config.idPrefix = 'pcloud'
  })
})
